// src/helpers/formatters.js

export const formatNumber = (value) => {
    if (isNaN(value)) return value;
    return new Intl.NumberFormat("es-PE").format(value);
  };
  
  export const formatPercentage = (value, decimals = 2) => {
    if (isNaN(value)) return value;
    return `${Number(value).toFixed(decimals)}%`;
  };
  